import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController, Platform, PopoverController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { Profile } from 'src/app/data/schema/profile';
import { RaffleService } from 'src/app/data/service/raffle.service';
import { BrowserHelper } from 'src/app/core/helper/browser.helper';
import { HeaderPopoverMenuComponent } from '../header-popover-menu/header-popover-menu.component';
import { RaffleStatus } from 'src/app/data/schema/raffle';
import { RejectReasonDetailPage } from 'src/app/modules/admin/modal/reject-reason-detail/reject-reason-detail.page';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
})
export class AdminHeaderComponent implements OnInit, OnDestroy {

  static showWarning = false;
  static warningDismissed = false;

  @Input() showPreview = true;
  @Input() previewBtnId: string;
  @Input() showAccountInfo = true;

  isMobile = false;
  profile: Profile = new Profile();
  isActingAs = false;
  showRejectReasonWarning = false;
  private subscription: Subscription;

  constructor(
    private authSvc: AuthenticationService,
    private popoverCtrl: PopoverController,
    private navCtrl: NavController,
    private browserHelper: BrowserHelper,
    private raffleSvc: RaffleService,
    private modalCtrl: ModalController
  ) {
    this.isActingAs = this.authSvc.isSuper;
    this.isMobile = (window.innerWidth < 800);

    this.subscription = this.raffleSvc.raffleUpdated.subscribe(raffle => {
      this.updateRejectReasonWarning();
    });
  }

  static get rejectReasonWarningDismissed() {
    return AdminHeaderComponent.warningDismissed;
  }

  static set rejectReasonWarningDismissed(dismissed: boolean) {
    AdminHeaderComponent.warningDismissed = dismissed;
  }

  get warningVisible() {
    return AdminHeaderComponent.showWarning;
  }

  get raffle() {
    return this.raffleSvc.currentRaffle;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = (window.innerWidth < 800);
  }

  ngOnInit() {
    this.profile = this.authSvc.profile;
    this.updateRejectReasonWarning();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  async openOptions(evt: any) {
    const popover = await this.popoverCtrl.create({
      component: HeaderPopoverMenuComponent,
      event: evt,
      translucent: true,
      cssClass: 'header-popover'
    });
    await popover.present();
  }

  async openRejectReasonModal() {
    const modal = await this.modalCtrl.create({
      cssClass: 'reject-reason-modal',
      component: RejectReasonDetailPage,
      componentProps: { rejectReason: this.raffle?.rejectReason },
    });
    await modal.present();
  }

  previewRaffle() {
    this.browserHelper.openUrlInSystem(this.raffleSvc.currentRaffle.url);
  }

  async cancelViewAsAdmin() {
    if (this.authSvc.isSuper) {
      if (this.raffleSvc.currentRaffle != null) {
        // we've already loaded this raffle above, all we really need to do is navigate to the raffle admin page
        this.navCtrl.navigateRoot(`/l57admin/raffle-review/${this.raffleSvc.currentRaffle.raffleId}`);
      } else {
        this.navCtrl.navigateRoot(`/l57admin/search`);
      }
    }
  }

  closeWarning() {
    AdminHeaderComponent.showWarning = false;
  }

  closeRejectReasonWarning() {
    // we need to store the dismiss status for the current raffle's reject reason length as that is a safe-ish way to track it
    localStorage.setItem(`rejectReasonWarningDismissed-${this.raffle?.raffleId}`, this.raffle?.rejectReason?.length.toString() ?? '0');
    this.updateRejectReasonWarning();
  }

  private updateRejectReasonWarning() {

    AdminHeaderComponent.rejectReasonWarningDismissed =
      localStorage.getItem(`rejectReasonWarningDismissed-${this.raffle?.raffleId}`) === this.raffle?.rejectReason?.length.toString();

    this.showRejectReasonWarning = this.showPreview === false || AdminHeaderComponent.rejectReasonWarningDismissed || this.raffle == null
      ? false
      : this.raffle.status === RaffleStatus.Draft && this.raffle.rejectReason?.length > 0;
  }
}
